import type { Profile, UUID } from "@/core/types";
import type { RootState } from "@/lib/types/state";

export const selectProfile = (state: RootState): Profile | undefined => {
  return state?.auth?.profile;
};

export const selectPatientId = (state: RootState): undefined | UUID => {
  return state?.auth?.profile?.username;
};
